import React, { useEffect, useState } from 'react';
import './PromoBanner.css';

const PromoBanner = () => {
  const [isVisible, setIsVisible] = useState(true);

  const messages = [
    "🎉 10% OFF on ALL Products - Limited Time Offer!",
    "⚡ Limited Stock on Lamps - Order Now Before They're Gone!",
    "🚚 FREE delivery on orders ₹199+ — add a little more to your cart!",
    "✨ New Arrivals - Check Out Our Latest Collection!"
  ];

  const [currentMessage, setCurrentMessage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % messages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [messages.length]);

  if (!isVisible) return null;

  return (
    <div className="promo-banner">
      <div className="promo-content">
        <div className="promo-text-wrapper">
          <p className="promo-text" key={currentMessage}>
            {messages[currentMessage]}
          </p>
        </div>
        <button 
          className="promo-close" 
          onClick={() => setIsVisible(false)}
          aria-label="Close banner"
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default PromoBanner;
